import { t } from "i18next";
import { useContext, useEffect, useState } from "react";
import { ListGroup } from "react-bootstrap";
import { Link } from "react-router-dom";
import { UserContext } from "../../App";
import { getUserWearables } from "../../services/user";
import { emptyUserWearables, UserWearables } from "../../interfaces/user";

interface MainMenuItemsProps {
    close: CallableFunction;
}

export function MainMenuItems(props: MainMenuItemsProps) {
    const { userProfile } = useContext(UserContext);

    const handleClose = (event: any) => {
        props.close();
    }

    return (
        <div className="menu-items-container">
            { userProfile.role.filter((r: any) => r.id == 'padeltech_administrator').length > 0 &&
                <div className="menu-block">
                    <ListGroup>
                        <ListGroup.Item>
                            <Link to="/admin/users" onClick={ handleClose }>
                                { t("users")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/admin/categories" onClick={ handleClose }>
                                { t("categories")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/admin/speciality" onClick={ handleClose }>
                                { t("specialities")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/admin/modality" onClick={ handleClose }>
                                { t("modalities")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/admin/seasons" onClick={ handleClose }>
                                { t("seasons")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/admin/clubs" onClick={ handleClose }>
                                { t("clubs")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/admin/teams" onClick={ handleClose }>
                                { t("teams")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/admin/athletes" onClick={ handleClose }>
                                { t("athletes")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/admin/staff" onClick={ handleClose }>
                                { t("Coaches")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/admin/competitions" onClick={ handleClose }>
                                { t("competitions")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/admin/events" onClick={ handleClose }>
                                { t("Events")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/admin/videos" onClick={ handleClose }>
                                { t("videos")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/documents" onClick={ handleClose }>
                                { t("Document Management")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/coach/planning" onClick={ handleClose }>
                                { t("Planning")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/coach/planning/view" onClick={ handleClose }>
                                { t("Weekly Planning View")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/coach/trainings" onClick={ handleClose }>
                                { t("trainings")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/coach/planning/reports" onClick={ handleClose }>
                                { t("Planning reports")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/coach/reports" onClick={ handleClose }>
                                { t("Athletes reports")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/coach/monitoring-history" onClick={ handleClose }>
                                { t("Monitoring history")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/admin/settings" onClick={ handleClose }>
                                { t("Settings")}
                            </Link>
                        </ListGroup.Item>
                    </ListGroup>
                </div>
            }
            { userProfile.role.filter((r: any) => r.id == 'padeltech_manager').length > 0 &&
                <div className="menu-block">
                    <ListGroup>
                        <ListGroup.Item>
                            <Link to="/" onClick={ handleClose }>
                                { t("my_space")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/manager/athletes" onClick={ handleClose }>
                                { t("athletes")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/manager/staff" onClick={ handleClose }>
                                { t("Coaches")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/manager/teams" onClick={ handleClose }>
                                { t("teams")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/manager/videos" onClick={ handleClose }>
                                { t("videos")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/documents" onClick={ handleClose }>
                                { t("Document Management")}
                            </Link>
                        </ListGroup.Item>
                        {/*<ListGroup.Item>
                            <Link to="/reports" onClick={ handleClose }>
                                { t("Reports")}
                            </Link>
                        </ListGroup.Item>*/}
                    </ListGroup>
                </div>
            }
            { userProfile.role.filter((r: any) => r.id == 'padeltech_coach').length > 0 &&
                <div className="menu-block">
                    <ListGroup>
                        <ListGroup.Item>
                            <Link to="/" onClick={ handleClose }>
                                { t("my_space")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/coach/athletes" onClick={ handleClose }>
                                { t("athletes")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/coach/teams" onClick={ handleClose }>
                                { t("teams")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/coach/planning" onClick={ handleClose }>
                                { t("Planning")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/coach/planning/view" onClick={ handleClose }>
                                { t("Weekly Planning View")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/coach/trainings" onClick={ handleClose }>
                                { t("trainings")}
                            </Link>
                        </ListGroup.Item>
                        {/* <ListGroup.Item>
                            <Link to="/coach/training-sessions" onClick={ handleClose }>
                                { t("training_sessions")}
                            </Link>
                        </ListGroup.Item> */}
                        <ListGroup.Item>
                            <Link to="/coach/videos" onClick={ handleClose }>
                                { t("videos")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/documents" onClick={ handleClose }>
                                { t("Document Management")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/coach/planning/reports" onClick={ handleClose }>
                                { t("Planning reports")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/coach/reports" onClick={ handleClose }>
                                { t("Athletes reports")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/coach/monitoring-history" onClick={ handleClose }>
                                { t("Monitoring history")}
                            </Link>
                        </ListGroup.Item>
                    </ListGroup>
                </div>
            }
            { userProfile.role.filter((r: any) => r.id == 'padeltech_athlete').length > 0 &&
                <div className="menu-block">
                    <ListGroup>
                        <ListGroup.Item>
                            <Link to="/" onClick={ handleClose }>
                                { t("my_space")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/athlete/planning/view" onClick={ handleClose }>
                                { t("Weekly Planning View")}
                            </Link>
                        </ListGroup.Item>
                        {/*<ListGroup.Item>
                            <Link to="/coach/training-sessions" onClick={ handleClose }>
                                { t("training_sessions")}
                            </Link>
                        </ListGroup.Item>*/}
                        <ListGroup.Item>
                            <Link to="/athlete/monitoring-history" onClick={ handleClose }>
                                { t("Monitoring history")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/athlete/videos" onClick={ handleClose }>
                                { t("videos")}
                            </Link>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <Link to="/documents" onClick={ handleClose }>
                                { t("Document Management")}
                            </Link>
                        </ListGroup.Item>
                        { userProfile.garmin_user_id.length >0 &&
                            <ListGroup.Item>
                                <Link to={ '/reports/athlete/' + userProfile.garmin_user_id + '/view'} onClick={ handleClose }>
                                    { t("Reports")}
                                </Link>
                            </ListGroup.Item>
                        }
                    </ListGroup>
                </div>
            }
        </div>
    );
}
